import { render } from "./ApprovalModal.vue?vue&type=template&id=79eaee41&scoped=true&ts=true"
import script from "./ApprovalModal.vue?vue&type=script&lang=ts"
export * from "./ApprovalModal.vue?vue&type=script&lang=ts"

import "./ApprovalModal.vue?vue&type=style&index=0&id=79eaee41&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79eaee41"]])

export default __exports__